export default __webpack_public_path__ + "static/media/jeans_2.a59954a2.jpg";